import React from 'react';
import { UserEntity } from '@interpals/api-web';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { makeProfileURL } from 'routes';
import Typography from 'components/ui/Typography';
import UserAvatar from 'components/UserAvatar';
import { UserAvatarProps } from 'components/UserAvatar/UserAvatar';

import css from './UserAvatarLink.module.scss';

export interface UserAvatarLinkProps extends UserAvatarProps {
    user?: Pick<UserEntity, 'id' | 'username' | 'avatar' | 'name' | 'sex' | 'online' | 'country_code'>;
    withName?: boolean;
}

const UserAvatarLink: React.FC<UserAvatarLinkProps> = ({ user, withName = true, ...rest }) => {
    const { t } = useTranslation();

    return user ? (
        <Link to={makeProfileURL(user.username)} key={user.id} className={css.wrapper}>
            <UserAvatar user={user} {...rest} />
            {withName && (
                <Typography
                    ellipsis
                    align="center"
                    color={user.sex === 'male' ? 'male' : 'female'}
                    style="BodyMedSemibold"
                    className={css.name}
                >
                    {user.name}
                </Typography>
            )}
        </Link>
    ) : (
        <div className={css.wrapper}>
            <UserAvatar user={user} {...rest} />
            <Typography ellipsis align="center" style="BodyMedSemibold" className={css.name}>
                {t('Common.Deleted')}
            </Typography>
        </div>
    );
};

export default React.memo(UserAvatarLink);
